import { render, staticRenderFns } from "./SpThreeModule3.vue?vue&type=template&id=95fa20b0&scoped=true"
import script from "./SpThreeModule3.vue?vue&type=script&lang=js"
export * from "./SpThreeModule3.vue?vue&type=script&lang=js"
import style0 from "./SpThreeModule3.vue?vue&type=style&index=0&id=95fa20b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fa20b0",
  null
  
)

export default component.exports